import { Tab as TabElement } from '@headlessui/react';
import { ReactNode, useEffect, useState } from 'react';
import Badgev2 from '../../badge/Badgev2';

const styles = {
    tab: {
        underline: {
            unselected: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
            selected: 'border-blue-500 text-blue-600',
            default:
                'whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm cursor-pointer group inline-flex items-center cursor:pointer',
        },
        filled: {
            unselected: 'border-transparent text-gray-500 hover:text-gray-700',
            selected: 'bg-blue-100 text-blue-700 font-medium text-sm rounded-md',
            default: 'whitespace-nowrap py-2 px-3 font-medium text-sm cursor-pointer mb-2 group inline-flex items-center cursor:pointer',
        },
    },
    badge: {
        unselected: 'bg-gray-100 text-gray-900',
        selected: 'bg-blue-100 text-blue-600',
        default: 'ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium inline-block',
    },
    icon: {
        red: 'text-red-600',
        green: 'text-green-600',
    },
};

export type Tab = {
    label: string;
    figure?: number;
    icon?: ReactNode;
    disabled?: boolean;
};

export type StandardTabsProps = {
    onChange: (index: number) => void;
    defaultIndex?: number;
    tabs: Tab[];
};

function Tabs({ onChange, tabs, defaultIndex = 0 }: StandardTabsProps): JSX.Element {
    const [selected, setSelected] = useState(defaultIndex);

    useEffect(() => {
        setSelected(defaultIndex);
    }, [defaultIndex]);

    function handleChange(index: number): void {
        setSelected(index);
        onChange(index);
    }

    return (
        <div>
            <TabElement.Group onChange={handleChange} selectedIndex={selected}>
                <TabElement.List className="border-gray-200 border-b -mb-px flex space-x-4 overflow-x-auto">
                    {tabs.map((tab, idx) => {
                        return (
                            <TabElement
                                key={idx}
                                disabled={tab.disabled}
                                className={`outline-none ${tab.disabled ? 'pointer-events-none' : ''}`}
                            >
                                {({ selected }): JSX.Element => {
                                    const style = selected
                                        ? 'border-indigo-500 text-indigo-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300';
                                    return (
                                        <span
                                            className={`${style} whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm cursor-pointer group inline-flex items-center cursor:pointer`}
                                        >
                                            {tab.icon && (
                                                <span
                                                    className={`${
                                                        selected ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500'
                                                    } -ml-0.5 mr-2 h-5 w-5`}
                                                >
                                                    {tab.icon}
                                                </span>
                                            )}
                                            {tab.label}
                                            {tab.figure !== undefined && (
                                                <span className="ml-3">
                                                    <Badgev2
                                                        label={tab.figure.toString()}
                                                        shape="rounded"
                                                        size="small"
                                                        color={selected ? 'indigo' : 'gray'}
                                                    />
                                                </span>
                                            )}
                                        </span>
                                    );
                                }}
                            </TabElement>
                        );
                    })}
                </TabElement.List>
            </TabElement.Group>
        </div>
    );
}

// type TabProps = {
//     label: string;
//     style: 'underline' | 'filled';
//     children: ReactNode[] | ReactNode;
// };

// function Tab({ children, style }: TabProps): JSX.Element {
//     const btnClass = style === 'filled' ? styles.tab.filled : styles.tab.underline;

//     return (
//         <TabElement as={Fragment}>
//             {({ selected }): JSX.Element => {
//                 return (
//                     <button className={`${btnClass.default} ${selected ? btnClass.selected : btnClass.unselected}`}>
//                         {/* <TabContext.Provider value={selected}>{children}</TabContext.Provider> */}
//                     </button>
//                 );
//             }}
//         </TabElement>
//     );
// }

// type TabLabelProps = {
//     children: string;
// };
// export function TabLabel({ children }: TabLabelProps): JSX.Element {
//     return <label className="cursor-pointer">{children}</label>;
// }

// type TabBadgeProps = {
//     figure: number;
// };
// export function TabBadge({ figure }: TabBadgeProps): JSX.Element {
//     return (
//         <TabContext.Consumer>
//             {(selected): JSX.Element => {
//                 return (
//                     <span className={`${styles.badge.default} ${selected ? styles.badge.selected : styles.badge.unselected}`}>
//                         {figure > 99 ? '99+' : figure}
//                     </span>
//                 );
//             }}
//         </TabContext.Consumer>
//     );
// }

// type TabIconProps = {
//     children: ReactNode;
//     color?: string;
// };
// function TabIcon({ children, color }: TabIconProps): JSX.Element {
//     return <span>{children}</span>;
// }

// TabGroup.Tab = Tab;

// Tab.Label = TabLabel;
// Tab.Badge = TabBadge;
// Tab.Icon = TabIcon;

export default Tabs;
